module.exports = __webpack_public_path__ + "img/logo-contigo-seguros-white.a5ad1cf0.png";